<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />

                <a-divider type="vertical" class="item" />

                <a-radio-group
                    v-model="search.audit_status"
                    button-style="solid"
                    @change="(e) => on_field_change(e.target.value, 'audit_status')"
                    class="item"
                >
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="1">待处理</a-radio-button>
                    <a-radio-button value="2">审核成功</a-radio-button>
                    <a-radio-button value="3">审核失败</a-radio-button>
                </a-radio-group>

            </div>

            <div class="right-items">
                <a-input-search placeholder="搜索流水号" enter-button @search="on_search" class="item" v-model="wd" />
            </div>
        </div>

        <div class="main">
            <a-spin tip="加载中" :spinning="loading">
                <div class="items" v-if="loading || data_source.length">
                    <section class="item" v-for="item in data_source" :key="item.transaction_no">
                        <div class="head">
                            <div class="date">
                              申请时间：
                                <span
                                    v-html="$options.filters['friendly'](moment(item.created_at * 1000).format('YYYY-MM-DD HH:mm'))"
                                ></span>
                            </div>

                            <div class="order-no">
                                审批类型：
                                {{ item.type_name }}
                            </div>
                        </div>
                        <div class="body">
                          <div class="supplier">
                            <div class="thumb">
                              <img
                                  style="width:90px;height:90px"
                                  v-lazy="item.trademark.logo"
                                  onerror="this.src='https://scxm.oss-cn-hangzhou.aliyuncs.com/assets/images/img_missing.png'"
                              />
                            </div>
                            <div class="detail">
                              <div class="name">
                                <a :href="'https://fsadmin.shoptm.cn/trademark/whole?markName='+item.trademark.markName" target="_blank"> {{ item.trademark.markName }} </a>
                              </div>
                              <div class="name-b">{{ item.trademark.internationalGroup }}类 <br>商标号：{{ item.apply_no }}</div>
                            </div>
                          </div>

                            <div class="supplier">
                                <div class="corner">客户信息</div>
                                <template v-if="item.id">
                                    <div class="name">
                                        <div class="id">客户名称：{{ item.member ? item.member.name : null }}</div>
                                        <div class="id">ID：{{ item.member ? item.member.id : null }}</div>
                                        <div class="id">公司：{{ item.member ? item.member.com_name : null }}</div>
                                    </div>
                                </template>
                            </div>

                          <div class="supplier">
                            <div class="corner">销售信息</div>
                            <template v-if="item.sale">
                              <div class="name">
                                <div class="id">销售名称：{{ item.sale.name }}</div>
                                <div class="id">ID：{{ item.sale.id }}</div>
                              </div>
                            </template>
                          </div>
                          <div class="supplier">
                            <div class="corner">付款信息</div>
                            <template>
                              <div class="name">
                                <div class="id">付款金额：{{ item.amount }}</div>
                                <div class="id">付款截图：<a v-if="item.screenshot" :href="item.screenshot" target="_blank">查看付款截图</a></div>
                                <div class="id">备注：{{ item.remark }}</div>

                              </div>
                            </template>
                          </div>

                          <div class="supplier">
                            <div class="corner">审批说明</div>
                            <template>
                              <div class="name">
                                <div class="id">状态：{{ item.status_name }}</div>
                                <div class="id">审批时间：{{item.status > 1 ? moment(item.updated_at * 1000).format("MM-DD HH:mm") : null}}</div>
                                <div class="id">审批备注：{{ item.message }}</div>
                              </div>
                            </template>
                          </div>

                            <div class="action">
                                <a-button size="small" @click="on_approve(item,1)" :disabled="item.status != 1">同意</a-button>
                                <a-button type="danger" size="small" @click="on_approve(item,2)" :disabled="item.status != 1">拒绝</a-button>
                            </div>
                        </div>
                    </section>
                </div>
            </a-spin>

            <!-- 分页 -->
            <div class="page" v-if="pagination && pagination.current > 0 && data_source.length">
                <div></div>
                <a-pagination
                    :disabled="loading"
                    v-model="pagination.current"
                    :total="pagination.total"
                    :page-size.sync="pagination.pageSize"
                    show-size-changer
                    showQuickJumper
                    :pageSizeOptions="['20', '50', '100', '200']"
                    @change="(page, pageSize) => on_pagination_change_common(page, pageSize)"
                    :show-total="(total, range) => `${range[0]}-${range[1]} , 展示 ${total} 条，实际 ${pagination.totalReality || '-'} 条`"
                />
            </div>

            <a-empty :image="simpleImage" v-if="!loading && !data_source.length" style="margin-top: 96px;">
                <a-button @click="load" icon="reload" style="margin-right:24px;">
                    刷新
                </a-button>
                <a-button @click="on_reset" icon="rollback">重置</a-button>
            </a-empty>

            <!-- <h2 class="h2"><a-icon type="info-circle" style="margin-right:12px" />使用说明</h2>

            <div class="explain-block">
                <ul>
                    <li>当客户通过转账或者汇款的方式进行充值时，请为充值的客户提交充值申请。</li>
                    <li>
                        请务必上传客户充值成功截图，且提交准备的充值时间以便财务核实。
                    </li>
                </ul>
            </div> -->
        </div>

        <!-- 拒绝原因 -->
        <modal_reject
            type="recharge"
            @close="visible_reject = false"
            :visible="visible_reject"
            :transaction_no="selected_record.transaction_no"
            :callback="load"
        />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../../mixins/common_pagination.js";
    import commonjs from "../common/common.js";
    import { Empty } from "ant-design-vue";
    import modal_reject from "../common/modal_reject";

    export default {
        beforeCreate() {
            this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
        },
        components: { modal_reject },
        mixins: [common_pagination, commonjs],
        data() {
            return {
                path: "/finance/audit/recharge",
                data_source: [],
                loading: false,
                wd: null,
                search: { audit_status: "" },
                data_summary: {
                    amount: 0,
                    amount_pend: 0,
                    amount_succeed: 0,
                },
            };
        },
        created() {
            this.$store.commit("change_state", {
                name: "sidebar_finance",
                value: "audit_recharge",
            });
            this.load();
            this.reset_query();
            //this.load_summary();
        },
        watch: {
            $route() {
                this.reset_query();
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/finance/audit/recharge?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            load_summary() {
                this.$http
                    .get(`/finance/recharge/summary`)
                    .then((res) => {
                        if (res.success) {
                            this.data_summary = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            reset_query() {
                let query = this.$route.query;
                this.wd = "wd" in query ? query["wd"] : "";
                this.search.audit_status = "audit_status" in query ? query["audit_status"] : "";
                this.search.type = "type" in query ? query["type"] : "";
            },
            on_approve(record,type) {
                this.$confirm({
                    title: "确认操作？",
                    centered: true,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve) => {
                            this.$http
                                .post("/finance/audit/recharge/approve", { id: record.id,type:type })
                                .then((res) => {
                                    if (res.success) {
                                        this.$message.success(res.message);
                                        this.load();
                                    } else {
                                        this.$error({
                                            title: "失败",
                                            centered: true,
                                            content: res.message,
                                        });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .summary {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }

        .items {
            min-height: 200px;
            .item {
                border: 1px solid #e8e8e8;
                margin: 16px;
                border-radius: 5px;
                overflow: hidden;
                min-width: 200px;
                &:hover {
                    box-shadow: 0 6px 16px -8px #00000014, 0 9px 28px 0 #0000000d, 0 12px 48px 16px #00000008;
                }
                .head {
                    padding: 8px 16px;
                    display: flex;
                    align-items: center;
                    background: #f1f1f1;
                    .date {
                        margin-right: 24px;
                        color: #9e9e9e;
                        min-width: 120px;
                    }
                }
                .body {
                    display: flex;
                    .status {
                        min-width: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        font-weight: bold;
                    }
                    .order {
                        display: flex;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        min-width: 250px;
                        width: 100%;

                        .thumb {
                            margin-right: 12px;
                            text-align: center;
                            margin-left: 12px;
                        }
                        .detail {
                            padding: 16px;
                            .name {
                                font-size: 14px;
                                margin-bottom: 4px;
                            }
                            .more {
                                font-size: 12px;
                            }
                            .name-b {
                                font-size: 12px;
                            }
                        }
                    }
                    .amount {
                        padding: 16px;
                        min-width: 150px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .type {
                            border-right: 1px solid #efefef;
                            padding-right: 24px;
                            margin-right: 24px;
                            font-weight: bold;
                        }
                        .price {
                            font-size: 16px;
                            font-weight: bold;
                        }
                        .lirun {
                            font-size: 12px;
                            span {
                                color: red;
                            }
                        }
                    }
                    .supplier {
                        min-width: 300px;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .name {
                            min-width: 80px;
                            font-weight: bold;
                            .id {
                                font-size: 12px;
                                color: #9e9e9e;
                                font-weight: normal;
                            }
                        }
                        .payment {
                            font-size: 12px;
                            color: #9e9e9e;
                        }
                        .corner {
                            position: absolute;
                            right: 0;
                            top: 0;
                            height: 24px;
                            padding: 0 8px;
                            background: #fafafa;
                            color: #00000073;
                            font-size: 12px;
                            text-align: center;
                            line-height: 24px;
                        }
                    }

                    .creater {
                        min-width: 150px;
                        padding: 16px;
                        border-right: 1px solid #efefef;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .date {
                            font-size: 12px;
                            color: #9e9e9e;
                        }
                    }
                    .remark {
                        min-width: 150px;
                        width: 100%;
                        border-right: 1px solid #efefef;
                        padding: 16px;
                    }
                    .action {
                        min-width: 80px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        .ant-btn {
                            &:first-child {
                                margin-bottom: 4px;
                            }
                        }
                    }
                }
                .foot {
                    background: #fffbe6;
                    padding: 4px 16px;
                    font-size: 12px;
                    .icon {
                        margin-right: 8px;
                    }
                }
            }
        }
        .page {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            .tips {
                font-size: 12px;
                color: #9e9e9e;
            }
        }
    }
</style>
